import React from "react";
import { useSelector } from "react-redux";
import VideoBackground from "./VideoBackground";
import VideoTitle from "./VideoTitle";

const MainContainer = () => {
  const movie = useSelector((store) => store.movie?.nowPlayingMovies);
  if (!movie) return; // early return if no movie data

  const { overview, id, title } = movie[4]; // Adjust as needed for dynamic data

  return (
    <div className="relative w-full h-screen overflow-hidden -mt-10">
      {/* Video Background */}
      <VideoBackground movieId={id} />
      
      {/* Video Title Section */}
      <VideoTitle title={title} overview={overview} />
    </div>
  );
};

export default MainContainer;
